//全局页面跳转是否启用loading
export const routerLoading = true;
  
//全局api接口调用是否启用loading
export const apiLoading = true;
 
//loading参数配置
export const loadingConfig = {
  lock: true,
  text: 'Loading',
  spinner: 'el-icon-loading',
  background: 'rgba(0, 0, 0, 0.7)'
}